import React, { Component } from "react";
import PropTypes from "prop-types";

import gpt from "../../../utils/gpt";

class Advert extends Component {

  componentDidMount() {
    const { id, advert, stream, adId } = this.props;
    if (advert && gpt) {
      const { index, postIds, beforeTags, afterTags } = advert;
      gpt.setupAd(id, stream, index, postIds, beforeTags, afterTags, adId);
    }
  }

  render() {
    return <div id={this.props.id} className="advert-card"/>;
  }
}

Advert.propTypes = {
  id: PropTypes.string.isRequired,
  advert: PropTypes.object.isRequired,
  stream: PropTypes.string.isRequired,
  adId: PropTypes.string,
};

export default Advert;



// WEBPACK FOOTER //
// ./src/components/Library/Advert/Advert.js